/**
 * Resolve clientId to a display name for UI (e.g. Feature Adoption table, Clients Reached).
 * Uses loginDetails.clientData when available; falls back to clientId.
 * @param {object|null} loginDetails - from localStorage "loginDetails"
 * @param {string} clientId
 * @returns {string} display name or clientId
 */
export function getClientDisplayName(loginDetails, clientId) {
    if (!clientId) return "";
    if (!loginDetails?.clientData?.length) return clientId;
    const c = loginDetails.clientData.find(
        (item) => (item.clientId || "") === clientId
    );
    if (!c) return clientId;
    return (
        (c.displayName || c.customerName || c.org || "").trim() || clientId
    );
}
